@if (isOpen()) {
  <div class="palette__backdrop" (click)="close()">
    <div
      class="palette"
      role="dialog"
      aria-modal="true"
      [attr.aria-label]="'palette.label' | translate"
      (click)="$event.stopPropagation()"
    >
      <div class="palette__search">
        <i class="pi pi-search" aria-hidden="true"></i>
        <input
          #search
          type="text"
          autocomplete="off"
          [attr.placeholder]="'palette.placeholder' | translate"
          [attr.aria-label]="'palette.placeholder' | translate"
          [value]="query()"
          (input)="query.set($any($event.target).value)"
          (keydown)="onSearchKeydown($event)"
        />
        <kbd>Esc</kbd>
      </div>

      <ul class="palette__results" role="listbox">
        @for (entry of filtered(); track entry.key; let i = $index) {
          <li>
            <button
              type="button"
              class="palette__entry"
              role="option"
              [class.palette__entry--selected]="i === selected()"
              [attr.aria-selected]="i === selected()"
              (mouseenter)="selected.set(i)"
              (click)="activate(entry)"
            >
              <i class="palette__icon" [class]="entry.icon" aria-hidden="true"></i>
              <span class="palette__label">{{ entry.labelKey | translate }}</span>
              @if (entry.detailKey; as detail) {
                <span class="palette__detail">{{ detail | translate }}</span>
              }
            </button>
          </li>
        } @empty {
          <li class="palette__empty">{{ 'palette.empty' | translate }}</li>
        }
      </ul>
    </div>
  </div>
}
